import React from 'react';
export { Pagination } from './Pagination';
export { BranchFilterSelect } from './BranchFilterSelect';

export const LoadingSpinner: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <div className="inline-block">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
      <p className="mt-4 text-gray-600">Loading...</p>
    </div>
  </div>
);

export const DataTable: React.FC<{
  columns: Array<{ header: string; accessor: string }>;
  data: any[];
  onRowClick?: (row: any) => void;
}> = ({ columns, data, onRowClick }) => (
  <div className="overflow-x-auto ui-table-wrap">
    <table className="w-full ui-table">
      <thead className="bg-gray-50">
        <tr>
          {columns.map((col) => (
            <th key={col.accessor} className="text-left py-3 px-4 font-semibold">
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, idx) => (
          <tr
            key={idx}
            className="border-b hover:bg-gray-50 cursor-pointer"
            onClick={() => onRowClick?.(row)}
          >
            {columns.map((col) => (
              <td key={col.accessor} className="py-3 px-4">
                {typeof row[col.accessor] === 'object'
                  ? JSON.stringify(row[col.accessor])
                  : String(row[col.accessor])}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const ErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    const handler = (error: ErrorEvent) => {
      console.error(error);
      setHasError(true);
    };

    window.addEventListener('error', handler);
    return () => window.removeEventListener('error', handler);
  }, []);

  if (hasError) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-red-600 mb-2">Something went wrong</h1>
          <p className="text-gray-600 mb-4">Please try refreshing the page</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Refresh
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export const EmptyState: React.FC<{ title: string; description?: string; action?: React.ReactNode }> = ({
  title,
  description,
  action,
}) => (
  <div className="text-center py-12">
    <h3 className="text-lg font-medium text-gray-900">{title}</h3>
    {description && <p className="mt-1 text-gray-500">{description}</p>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);

